import _objectWithoutProperties from "/codebuild/output/src4019196394/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/ca.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["linkResolver", "field", "fallback", "components", "externalLinkComponent", "internalLinkComponent"];
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { jsx, Fragment } from "react/jsx-runtime";
import * as React from "react";
import * as prismicR from "@prismicio/richtext";
import { PrismicLink } from "./PrismicLink.js";
import { devMsg } from "../lib/devMsg.js";
import { richText } from './../_node_modules/@prismicio/client/dist/helpers/isFilled.js';
var createDefaultSerializer = function createDefaultSerializer(args) {
  return prismicR.wrapMapSerializer({
    heading1: function heading1(_ref) {
      var children = _ref.children,
        key = _ref.key;
      return /* @__PURE__ */jsx("h1", {
        children: children
      }, key);
    },
    heading2: function heading2(_ref2) {
      var children = _ref2.children,
        key = _ref2.key;
      return /* @__PURE__ */jsx("h2", {
        children: children
      }, key);
    },
    heading3: function heading3(_ref3) {
      var children = _ref3.children,
        key = _ref3.key;
      return /* @__PURE__ */jsx("h3", {
        children: children
      }, key);
    },
    heading4: function heading4(_ref4) {
      var children = _ref4.children,
        key = _ref4.key;
      return /* @__PURE__ */jsx("h4", {
        children: children
      }, key);
    },
    heading5: function heading5(_ref5) {
      var children = _ref5.children,
        key = _ref5.key;
      return /* @__PURE__ */jsx("h5", {
        children: children
      }, key);
    },
    heading6: function heading6(_ref6) {
      var children = _ref6.children,
        key = _ref6.key;
      return /* @__PURE__ */jsx("h6", {
        children: children
      }, key);
    },
    paragraph: function paragraph(_ref7) {
      var children = _ref7.children,
        key = _ref7.key;
      return /* @__PURE__ */jsx("p", {
        children: children
      }, key);
    },
    preformatted: function preformatted(_ref8) {
      var node = _ref8.node,
        key = _ref8.key;
      return /* @__PURE__ */jsx("pre", {
        children: node.text
      }, key);
    },
    strong: function strong(_ref9) {
      var children = _ref9.children,
        key = _ref9.key;
      return /* @__PURE__ */jsx("strong", {
        children: children
      }, key);
    },
    em: function em(_ref10) {
      var children = _ref10.children,
        key = _ref10.key;
      return /* @__PURE__ */jsx("em", {
        children: children
      }, key);
    },
    listItem: function listItem(_ref11) {
      var children = _ref11.children,
        key = _ref11.key;
      return /* @__PURE__ */jsx("li", {
        children: children
      }, key);
    },
    oListItem: function oListItem(_ref12) {
      var children = _ref12.children,
        key = _ref12.key;
      return /* @__PURE__ */jsx("li", {
        children: children
      }, key);
    },
    list: function list(_ref13) {
      var children = _ref13.children,
        key = _ref13.key;
      return /* @__PURE__ */jsx("ul", {
        children: children
      }, key);
    },
    oList: function oList(_ref14) {
      var children = _ref14.children,
        key = _ref14.key;
      return /* @__PURE__ */jsx("ol", {
        children: children
      }, key);
    },
    image: function image(_ref15) {
      var _node$alt;
      var node = _ref15.node,
        key = _ref15.key;
      var img = /* @__PURE__ */jsx("img", {
        src: node.url,
        alt: (_node$alt = node.alt) !== null && _node$alt !== void 0 ? _node$alt : void 0,
        "data-copyright": node.copyright ? node.copyright : void 0
      });
      return /* @__PURE__ */jsx("p", {
        className: "block-img",
        children: node.linkTo ? /* @__PURE__ */jsx(PrismicLink, {
          linkResolver: args.linkResolver,
          internalComponent: args.internalLinkComponent,
          externalComponent: args.externalLinkComponent,
          field: node.linkTo,
          children: img
        }) : img
      }, key);
    },
    embed: function embed(_ref16) {
      var _node$oembed$html;
      var node = _ref16.node,
        key = _ref16.key;
      return /* @__PURE__ */jsx("div", {
        "data-oembed": node.oembed.embed_url,
        "data-oembed-type": node.oembed.type,
        "data-oembed-provider": node.oembed.provider_name,
        dangerouslySetInnerHTML: {
          __html: (_node$oembed$html = node.oembed.html) !== null && _node$oembed$html !== void 0 ? _node$oembed$html : ""
        }
      }, key);
    },
    hyperlink: function hyperlink(_ref17) {
      var node = _ref17.node,
        children = _ref17.children,
        key = _ref17.key;
      return /* @__PURE__ */jsx(PrismicLink, {
        field: node.data,
        linkResolver: args.linkResolver,
        internalComponent: args.internalLinkComponent,
        externalComponent: args.externalLinkComponent,
        children: children
      }, key);
    },
    label: function label(_ref18) {
      var node = _ref18.node,
        children = _ref18.children,
        key = _ref18.key;
      return /* @__PURE__ */jsx("span", {
        className: node.data.label,
        children: children
      }, key);
    },
    span: function span(_ref19) {
      var text = _ref19.text,
        key = _ref19.key;
      var result = [];
      var i = 0;
      var _iterator = _createForOfIteratorHelper(text.split("\n")),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var line = _step.value;
          if (i > 0) {
            result.push( /* @__PURE__ */jsx("br", {}, "".concat(i, "__break")));
          }
          result.push( /* @__PURE__ */jsx(React.Fragment, {
            children: line
          }, "".concat(i, "__line")));
          i++;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return /* @__PURE__ */jsx(React.Fragment, {
        children: result
      }, key);
    }
  });
};
function PrismicRichText(_ref20) {
  var linkResolver = _ref20.linkResolver,
    field = _ref20.field,
    fallback = _ref20.fallback,
    components = _ref20.components,
    externalLinkComponent = _ref20.externalLinkComponent,
    internalLinkComponent = _ref20.internalLinkComponent,
    restProps = _objectWithoutProperties(_ref20, _excluded);
  return React.useMemo(function () {
    if (process.env.NODE_ENV === "development") {
      if ("className" in restProps) {
        console.warn("[PrismicRichText] className cannot be passed to <PrismicRichText> since it renders an array without a wrapping component. For more details, see ".concat(devMsg("classname-is-not-a-valid-prop"), "."), field);
      }
    }
    if (richText(field)) {
      var serializer = prismicR.composeSerializers(typeof components === "object" ? prismicR.wrapMapSerializer(components) : components, createDefaultSerializer({
        linkResolver: linkResolver,
        internalLinkComponent: internalLinkComponent,
        externalLinkComponent: externalLinkComponent
      }));
      var serialized = prismicR.serialize(field, function (type, node, text, children, key) {
        var result = serializer(type, node, text, children, key);
        if (React.isValidElement(result) && result.key == null) {
          return React.cloneElement(result, {
            key: key
          });
        } else {
          return result;
        }
      });
      return /* @__PURE__ */jsx(Fragment, {
        children: serialized
      });
    } else {
      return fallback != null ? /* @__PURE__ */jsx(Fragment, {
        children: fallback
      }) : null;
    }
  }, [field, internalLinkComponent, externalLinkComponent, components, linkResolver, fallback]);
}
export { PrismicRichText };